module.exports = __webpack_public_path__ + "static/img/m_icon.f6a88f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build08/components/base/login/m_icon.png
// module id = LYBB
// module chunks = 43